import PropTypes from "prop-types";
import { formatDate } from "../../../utils/date";
import Table from "../../Common/Tables/BaseTable";

const HEADERS = [
  "Dato",
  "Hovedgate",
  "Fra gate",
  "Til gate",
  "Tjenestenummer",
  "Kjennemerke",
];

function PiggdekkontrollList({ piggdekkontroller }) {
  return (
    <Table headerRow={HEADERS} striped>
      <tbody>
        {Array.isArray(piggdekkontroller) &&
          piggdekkontroller.map((kontroll, idx) => (
            <tr key={idx}>
              <td>
                {formatDate(new Date(kontroll.dato), "dateTimeWithSeconds", {
                  locale: "nb-NO",
                  timeZone: "Europe/Oslo",
                })}
              </td>
              <td>{kontroll.hovedgateNavn}</td>
              <td>{kontroll.fraGateNavn}</td>
              <td>{kontroll.tilGateNavn}</td>
              <td>{String(kontroll.tjenestenummer)}</td>
              <td>{kontroll.kjennemerke}</td>
            </tr>
          ))}
      </tbody>
    </Table>
  );
}

PiggdekkontrollList.propTypes = {
  piggdekkontroller: PropTypes.array,
};

export default PiggdekkontrollList;
